const lazyLoading = () => {
  const images = document.querySelectorAll('img.lazy');

  const loadImage = (image) => {
    const src = image.dataset.src;
    if (!src) return;

    // 1. Create an in-memory image object
    const imgPlaceholder = new Image();

    // 2. Set up the onload listener BEFORE setting the source
    imgPlaceholder.onload = () => {
      image.src = src;                 // Swap the actual source once cached
      image.removeAttribute('data-src');
      image.classList.remove('lazy'); // Optional: Remove lazy class for styling
    };

    // 3. Trigger the browser download
    imgPlaceholder.src = src;
  };

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadImage(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, options);

  images.forEach(image => {
        console.log('Observing image:', image);
    observer.observe(image);
  });
}

export {lazyLoading};
